<script>
import BreadcrumbsWrapper from '@components/breadcrumbs/breadcrumbs-wrapper.vue';
import EditableTextArea from '@components/editables/editable-text-area.vue';
import PhotoUploader from '@components/uploaders/photo-uploader.vue';
import resize from '@utils/image-sizer';

import {
  clientProgramComputed,
  clientProgramMethods,
  clientComputed,
  mediaComputed,
  mediaMethods,
  programComputed,
  programMethods,
  adminPanelComputed,
} from '@state/helpers';
import moment from 'moment';
import has from 'lodash/has';
import cloneDeep from 'lodash/cloneDeep';

export default {
  components: {
    BreadcrumbsWrapper,
    EditableTextArea,
    PhotoUploader,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: null,
    },
    description: {
      type: String,
      required: false,
      default: null,
    },
    client: {
      type: Object,
      required: false,
      default: null,
    },
    allowEditing: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      libraryplaceholder: require('@assets/images/placeholder-photo-upload.svg'),
      clientplaceholder: require('@assets/images/placeholder-client-program.jpg'),
      loadingWeeks: false,
      clearingAllProgram: false,
      editableKey: 0,
    };
  },
  computed: {
    ...clientProgramComputed,
    ...clientComputed,
    ...mediaComputed,
    ...programComputed,
    ...adminPanelComputed,
    coverPhoto() {
      if (
        // We check if url flag available before anything
        this.selectedProgram &&
        this.selectedProgram.mediaAssets &&
        this.selectedProgram.mediaAssets.coverPhoto &&
        has(this.selectedProgram.mediaAssets.coverPhoto, 'url')
      ) {
        if (this.programHasNewMedia && this.programHasNewMedia.success) {
          // If done Uploading
          return this.hasNewMedia('cover', 'programs').publicUrl;
        } else {
          if (this.tempPhotoPreview) {
            // Uploader component has temp photo
            return this.tempPhotoPreview;
          } else {
            if (
              // Have old url
              this.selectedProgram.mediaAssets.coverPhoto &&
              this.selectedProgram.mediaAssets.coverPhoto.url
            ) {
              return resize(
                this.selectedProgram.mediaAssets.coverPhoto.url,
                1200,
                360
              );
            } else {
              return this.libraryplaceholder;
            }
          }
        }
      } else {
        return this.libraryplaceholder;
      }
    },
    programHasNewMedia() {
      return this.hasNewMedia('cover', 'programs');
    },
  },
  mounted() {},
  methods: {
    ...mediaMethods,
    ...clientProgramMethods,
    ...programMethods,
    async onClearingAllProgram() {
      this.clearingAllProgram = true;
      const programId = this.client.program.program_id;
      const todaysDate = moment().format('YYYY-MM-DD');
      const clientProgramPayload = {
        id: programId,
        from: 1,
        to: this.selectedProgram.programWeeksNumber
          ? this.selectedProgram.programWeeksNumber
          : 4,
        today: todaysDate,
      };
      if (
        programId &&
        clientProgramPayload.id &&
        clientProgramPayload.from &&
        clientProgramPayload.to &&
        clientProgramPayload.today
      ) {
        await this.clearAllClientProgram(programId)
          .then(async (res) => {
            if (res) {
              await this.getAllClientProgram(clientProgramPayload).then(
                (res) => {
                  if (res && res.programWeeks) {
                    this.clearingAllProgram = false;
                  }
                }
              );
            }
            this.clearingAllProgram = false;
          })
          .catch((e) => console.log(e));
      }
    },
    async onUpdateProgram() {
      if (this.hasNewMedia('cover', 'programs')) {
        const porgramClone = cloneDeep(this.selectedProgram);
        const newCoverPhoto = this.hasNewMedia('cover', 'programs').publicUrl;
        porgramClone.mediaAssets.coverPhoto.url = newCoverPhoto;

        const payload = {
          programId: this.selectedProgram._id,
          orgId: this.selectedProgram.org_id,
          trainerId: this.selectedProgram.trainer_id,
          userId: this.selectedProgram.user_id,
          program: porgramClone,
        };
        if (
          payload.programId &&
          payload.trainerId &&
          payload.userId &&
          payload.program
        ) {
          await this.updateProgram(payload);
          if (this.allPrograms && this.allPrograms.length > 0) {
            await this.setUpdateProgramItem(this.selectedProgram);
          }
        }
      }
    },
    onChangeProgramTitle(val) {
      this.setSelectedProgram({ ...this.selectedProgram, label: val });
    },
    onChangeProgramDescription(e) {
      this.setSelectedProgram({
        ...this.selectedProgram,
        description: e.target.value,
      });
    },
    onChangeProgramWeeks(e) {
      this.$emit('on-change-program-weeks', e.target.value);
    },
  },
  watch: {
    async programHasNewMedia(val) {
      if (val && !this.isAdminPanelActive) {
        console.log(val);
        this.setSelectedProgram({
          ...this.selectedProgram,
          mediaAssets: { coverPhoto: { url: val.publicUrl } },
        });
        if (this.client) {
          try {
            await this.onUpdateProgram();
          } catch (e) {
            console.log(e);
          }
        }
      }
    },
    isAdminPanelActive(val) {
      if (!val) {
        this.clearMedia();
        this.setTempPhotoPreview(null);
      }
    },
    selectedProgram(n, o) {
      if (!o) {
        this.editableKey += 1;
      }
      if (o && n && o._id !== n._id) {
        this.editableKey += 1;
      }
    },
  },
};
</script>

<template>
  <div class="row hero">
    <div class="col-6">
      <BreadcrumbsWrapper prevPageName="Programs" />

      <div class="hero-section">
        <h6 v-if="!client" class="section-title">Program Title</h6>
        <h1 class="hero-title">
          <span v-if="client"
            >{{ client.profile.firstName }}'s<br />Program</span
          >
          <EditableTextArea
            :key="editableKey"
            v-if="!client && allowEditing"
            :text="title"
            mode="edit"
            :enableAutoExpand="true"
            placeholderTxt="Program Title"
            :canEdit="true"
            @update-editable-value="onChangeProgramTitle"
          />
          <span v-if="!allowEditing">{{ title }}</span>
        </h1>
        <h6 v-if="(client && description) || !client" class="section-title"
          >Description</h6
        >
        <p v-if="client && description" class="description-wrapper">
          {{ description }}
        </p>
        <p v-if="!client" class="description-wrapper-template">
          <BaseInputTextarea
            :value="description"
            name="description"
            @input="onChangeProgramDescription"
            :disabled="!allowEditing"
          />
        </p>

        <div v-if="!client" class="row">
          <div class="col-xl-3 col-lg-7 col-md-8">
            <span class="weeksInProgram">
              <label>Weeks In Program: </label>
            </span>
            <BaseInputText
              class="weeks-number"
              name="weeks"
              type="number"
              min="1"
              :value="selectedProgram.programWeeksNumber"
              @change="onChangeProgramWeeks"
              placeholder="4"
              :disabled="!allowEditing"
            />
            <BaseButton
              v-if="client"
              type="button"
              class="btn-secondary"
              @click="onClearingAllProgram"
              :disabled="loadingWeeks"
              ><BaseIcon v-if="clearingAllProgram" name="sync" spin />
              <span v-if="!clearingAllProgram"
                >Clear {{ client.profile.firstName }}'s Program</span
              >
            </BaseButton>
          </div>
        </div>
      </div>
    </div>

    <div class="col">
      <div class="hero-section">
        <div
          class="program-photo-wrapper"
          :style="{ 'background-image': `url(${coverPhoto})` }"
          >&nbsp;
          <span
            v-if="
              (hasNewMedia('cover', 'programs') &&
                !client &&
                hasNewMedia('cover', 'programs').uploadProgress < 100) ||
                (hasNewMedia('cover', 'programs') &&
                  client &&
                  hasNewMedia('cover', 'programs').uploadProgress < 100)
            "
            class="uploading-spinner"
          >
            <BaseIcon name="sync" spin src="@assets/images/icon-trash.svg"
          /></span>
        </div>

        <div class="row">
          <div class="col">
            <PhotoUploader
              requestType="programs"
              type="cover"
              :hidePlaceholder="true"
              :hidePhotoPreview="true"
              :hideButton="!allowEditing"
              :title="allowEditing ? 'Cover Photo' : ''"
              :helper-text="
                allowEditing
                  ? 'must be .jpg, .jpeg, .gif, or .webp, no larger than 4MB.'
                  : ''
              "
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';
// stylelint-disable selector-pseudo-element-no-unknown

.weeksInProgram {
  white-space: nowrap;
}
.uploading-spinner {
  @include calc-font-size(7.6);

  align-items: center;
  border-radius: 0.8rem;
  // background-color: rgba($color-black-wo-rgb, 0.4);
  color: rgba($color-black-wo-rgb, 0.6);
  cursor: pointer;
  display: flex;
  font-weight: 900;
  height: 27.6rem;
  justify-content: center;
  position: absolute;
  right: 1.6rem;
  // width: 48.6rem;
  width: 96%;
  z-index: 2;
}

.hero {
  justify-content: space-between;
  margin: 0 0 1.8rem;
  padding: 3.2rem 6rem 3.7rem;

  .hero-section {
    flex: 1;
    ::v-deep .button.btn-secondary {
      height: 4rem;
      margin-bottom: 1rem;
      white-space: nowrap;
      width: 20rem;
    }
  }

  .description-wrapper-template {
    background: $color-off-white;
    border-radius: $base-border-radius;
    height: 9.5rem;
    margin-bottom: 3.7rem;
    overflow-y: scroll;
    // padding: 1rem;

    ::v-deep .input-with-label {
      height: 100%;
      .input-textarea {
        height: 100% !important;
        line-height: 2;
        margin-bottom: unset;
        margin-top: unset;
        padding: 1rem !important;
      }
      .input-textarea:disabled {
        background-color: $color-white;
        border: none;
        resize: none;
      }
    }
  }

  .description-wrapper {
    background: $color-off-white;
    border-radius: $base-border-radius;
    height: 9.5rem;
    margin-bottom: 3.7rem;
    overflow-y: scroll;
    padding: 1rem;
  }

  .program-photo-wrapper {
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: $base-border-radius-md;
    height: 27.6rem;
    width: 100%;
  }

  .weeks-number {
    color: $color-text;
    font-family: $base-font-family;
    font-size: 1.3rem;
    font-weight: 600;
    // margin-left: 1rem;
    ::v-deep .input:disabled {
      background-color: $color-white;
      border: none;
    }
  }

  ::v-deep .weeks-number {
    input[type='number']::-webkit-inner-spin-button,
    input[type='number']::-webkit-outer-spin-button {
      margin: 0;
      opacity: 1;
    }
  }

  .more-weeks-btn {
    margin-bottom: 2rem;
    min-width: 80%;
    &:disabled {
      background-color: white;
      padding-bottom: 0.9rem;
      padding-top: 0.9rem;
    }
    &:hover:not(:disabled) {
      background: $color-button-bg;
    }
  }
}
</style>
